export default __webpack_public_path__ + "static/media/Screenshot (1138).49e59ba5.png";